import PlaceholderFlightEntry from './PlaceholderFlightEntry';

export default PlaceholderFlightEntry;
